import { ReactNode } from 'react';

import { CreateReport, UpdateReportInputs, UpdateSelectedTask } from '../hooks/types/request';
import { LibertyMutualReportDTO, LibertyMutualResultDTO } from '../hooks/types/response';

export enum HandCoupling {
	'Good' = 'Good',
	'Fair' = 'Fair',
	'Poor' = 'Poor'
}

export enum HandCouplingMapper {
	'GOOD' = 'Good',
	'FAIR' = 'Fair',
	'POOR' = 'Poor'
}

export enum FrequencyTimeFormatMapper {
	'MINUTE' = 'minute',
	'HOUR' = 'hour'
}

export enum TaskMapper {
	'Lifts' = 'lifts',
	'Lowers' = 'lowers',
	'Pushes' = 'pushes',
	'Pulls' = 'pulls',
	'Carries' = 'carries'
}

export type CreateOrUpdate = CreateReport | UpdateReportInputs | UpdateSelectedTask;

export type StepToMethodMapper = {
	[key: number]: (body: CreateOrUpdate) => Promise<LibertyMutualReportDTO> | void;
};

export type OptionType = { label: string; value: string } | undefined;

export type LibertyMutualSubStepsRouteParams = {
	file_id: string;
	report_id?: string;
	liberty_mutual_report_id: string;
};

export type SystemOfUnits = {
	[key: string]: string;
};

export type FormSubStep = {
	icon: ReactNode;
	title: string;
	component: JSX.Element;
};

export type States = {
	file_id: string;
	report_id?: string;
	subSteps: FormSubStep[];
	gettingReport: boolean;
	custom_report: boolean;
	decimalSeparator: string;
	errorGettingReport: boolean;
	liberty_mutual_report_id: string;
	libertyMutual: LibertyMutualReportDTO;
	libertyMutualResult: LibertyMutualResultDTO;
};

export type Methods = {
	handleUpdateReport(report: LibertyMutualReportDTO): void;
	useExistsReport(isSandbox: boolean, file_id: string | undefined, company_id: string | undefined, organization_id: string | undefined): { exists: boolean, isLoading: boolean };
};

export type Context = States & Methods;
